import type { ImportQueueStatus } from '@lib/import-queue-ui/types/import-queue-status';

import type { TemplateBulkImportStatus } from '../types/template-bulk-import-queue-item';

export function mapTemplateStatusToImportStatus(
  status: TemplateBulkImportStatus
): ImportQueueStatus {
  if (status === 'creating_deal') return 'preparing';
  return status;
}
